<template>
  <div class="max-w-xl m-auto pb-24">
    <loader v-if="loading === true"></loader>
    <fetch-error
      v-else-if="error instanceof FetchError"
      @retry="fetchData()"
      :error="error"
    ></fetch-error>
    <template v-else>
      <vs-row class="cont">
        <vs-col>
          <vx-card title="اطلاعات مجموعه">
            <div slot="actions">
              <div class="actions-wrapper">
                <vs-button
                  icon="icon-copy"
                  icon-pack="feather"
                  type="filled"
                  @click="copyProviderLink"
                  >کپی لینک مجموعه</vs-button
                >
                <div class="qr-wrapper">
                  <vs-button
                    icon="icon-maximize"
                    icon-pack="feather"
                    type="border"
                    style="font-weight: 500"
                    @click="getProviderQR('menu')"
                    >QR نمایش محصول</vs-button
                  >
                  <vs-button
                    icon="icon-maximize"
                    icon-pack="feather"
                    type="border"
                    style="font-weight: 500"
                    @click="getProviderQR('outdoor')"
                    >QR سفارش آنلاین</vs-button
                  >
                </div>
              </div>
            </div>
            <div style="position: relative">
              <div class="provider-logo-container">
                <image-cropper-input
                  id="profile-logo"
                  :image="profile.logo"
                  :aspectRatio="1"
                  childclass="provider-logo"
                  @input="handleUploadLogo($event)"
                />
              </div>
            </div>
            <vs-row>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                نام مجموعه (جهت نمایش در برنامه):
                <vs-input v-model="profile.name" class="w-100 mt-1" />
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                نام مجموعه به فارسی:
                <vs-input v-model="profile.persian_name" class="w-100 mt-1" />
              </vs-col>
              <vs-col vs-lg="4" vs-sm="6" vs-xs="12">
                نام مجموعه به انگلیسی:
                <vs-input v-model="profile.english_name" class="w-100 mt-1" />
              </vs-col>
              <vs-col vs-w="12">
                <notes />
              </vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
        <vs-col>
          <vx-card title="درباره ما">
            <vs-textarea v-model="profile.about" class="w-100 mt-1" />
          </vx-card>
        </vs-col>
        <vs-col>
          <vx-card title="بنرهای مجموعه">
            <attachments
              ref="coverAttachments"
              :data="profile.covers"
              :aspectRatio="2"
              accept="image/*"
            />
          </vx-card>
        </vs-col>
        <vs-col>
          <vs-row>
            <vs-col>
              <socials ref="socialsRef" :socialsData="profile.social_medias" />
            </vs-col>
            <vs-col>
              <phones ref="phonesRef" :phonesData="profile.phones" />
            </vs-col>
          </vs-row>
        </vs-col>
        <vs-col>
          <vx-card title="اطلاعات آدرس">
            <vs-row>
              <vs-col
                v-for="(item, index) in addresses"
                :key="item.id"
                vs-w="12"
                class="address-item"
              >
                <h5>{{ index + 1 }}. {{ item.location }}</h5>
                <div v-if="item.coordinates" class="mapContainer">
                  <LocationMap
                    mapStyle="height: 200px"
                    :coordinates="item.coordinates"
                    :isPreview="true"
                  />
                  <vs-button
                    @click="toggleAddressPopup(item)"
                    color="secondary"
                    class="button"
                    icon-pack="feather"
                    icon="icon-check"
                    >ویرایش آدرس</vs-button
                  >
                </div>
              </vs-col>
              <vs-col v-if="!addresses.length" vs-w="12">
                <div class="flex justify-start">
                  <vs-button
                    @click="toggleAddressPopup()"
                    color="secondary"
                    block
                  >
                    ایجاد آدرس
                  </vs-button>
                </div>
              </vs-col>
            </vs-row>
          </vx-card>
        </vs-col>
        <div class="footer">
          <loading-button
            @confirm="save"
            @cancelUpload="cancelUpload"
            title="ذخیره اطلاعات"
            :loading="loadingBtn"
            :progress="progress"
            className="save"
          />
          <vs-button
            @click="openInNewTab(providerLink)"
            color="inherit"
            block
            class="enter-menu"
            >ورود به منو</vs-button
          >
        </div>
      </vs-row>

      <working-hours />

      <vs-popup
        v-if="selectAddressVisible"
        title="انتخاب آدرس"
        :active.sync="selectAddressVisible"
      >
        <ProviderAddress
          @locationAdded="locationAdded"
          @locationRemoved="locationRemoved"
          :address="selectedAddress"
          :isUpdate="selectedAddress.id ? true : false"
        />
      </vs-popup>
    </template>
  </div>
</template>

<script>
  import FetchError from "../../../services/api/FetchError";
  import { mapGetters } from "vuex";
  import providerApiService from "../../../services/api/ProviderApiService";
  import { ArrayToJson } from "../../../helpers/array";
  import LocationMap from "../../../components/map/LocationMap.vue";
  import ProviderAddress from "../ProviderAddress.vue";
  import Notes from "./Notes.vue";
  import VxCard from "../../../components/VxCard.vue";
  import Socials from "./Socials.vue";
  import Phones from "./Phones.vue";
  import Attachments from "../../tickets/form/Attachments.vue";
  import WorkingHours from "../../workingHours/WorkingHours.vue";
  import LoadingButton from "../../../components/loading-button/LoadingButton.vue";

  export default {
    components: {
      LocationMap,
      ProviderAddress,
      Notes,
      VxCard,
      Socials,
      Phones,
      Attachments,
      LoadingButton,
      WorkingHours,
    },
    data() {
      return {
        profile: {
          id: null,
          name: null,
          persian_name: null,
          english_name: null,
          logo: null,
          phones: null,
          addresses: [],
          instagram: null,
          about: null,
          manager: null,
          slogan: null,
          covers: [],
        },
        providerLink: null,
        loading: true,
        loadingBtn: false,
        error: null,
        FetchError,
        Blob: window.Blob,
        addresses: [],
        selectedAddress: {
          id: 0,
          location: null,
          coordinates: null,
        },
        selectAddressVisible: false,
        progress: 0,
        abortController: null,
      };
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
    },
    methods: {
      copyProviderLink() {
        if (navigator.clipboard) {
          if (this.providerLink) {
            navigator.clipboard
              .writeText(this.providerLink)
              .then(() => {
                this.$vs.notify({
                  text: "لینک مجموعه با موفقیت کپی شد",
                  color: "success",
                  position: "bottom-center",
                });
              })
              .catch(() => {
                this.$vs.notify({
                  text: "خطا در کپی کردن لینک مجموعه",
                  color: "danger",
                  position: "bottom-center",
                });
              });
          }
        }
      },
      async getProviderQR(type) {
        this.$vs.loading();

        let link = this.providerLink;

        if (type === "menu") {
          link += `/products`;
        } else if (type === "outdoor") {
          link += `?type=outdoor`;
        }

        try {
          const { generateQr } = await import(
            "../../../utilities/qr/generate-qr"
          );
          await generateQr(link, type, "pdf");
        } catch (error) {
          this.$vs.notify({
            text: "خطا در ساخت QR",
            color: "danger",
            position: "bottom-center",
          });
        } finally {
          this.$vs.loading.close();
        }
      },
      mapAddress(address) {
        return {
          id: address.id,
          location: address.location,
          coordinates: [address.lt, address.lg],
        };
      },
      toggleAddressPopup(address = null) {
        this.selectedAddress = address
          ? { ...address }
          : { id: 0, location: null, coordinates: null };
        this.selectAddressVisible = true;
      },
      copyURL(text) {
        navigator.clipboard.writeText(text).then(() => {
          this.$vs.notify({
            text: "با موفقیت کپی شد!",
            position: "bottom-center",
            color: "success",
          });
        });
      },
      openInNewTab(url) {
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
      },
      fetchData() {
        this.loading = true;
        this.error = null;
        providerApiService
          .providerProfile(this.currentProvider.id)
          .then((providerProfile) => {
            this.profile = { ...providerProfile };
            this.addresses = (providerProfile.addresses || []).map((address) =>
              this.mapAddress(address)
            );
            this.providerLink =
              process.env.VUE_APP_MENU_LINK.replace(/\/+$/, "") +
              "/" +
              providerProfile.username;
          })
          .catch((err) => {
            this.error = err;
          })
          .finally(() => (this.loading = false));
      },
      save() {
        this.abortController = new AbortController();

        const socials = this.$refs["socialsRef"].getSocialMedias();
        if (socials) {
          const social_medias = ArrayToJson(socials);
          const phones = ArrayToJson(this.$refs["phonesRef"].getPhones());
          const covers = this.$refs.coverAttachments.getData();

          this.loadingBtn = true;
          providerApiService
            .storeOrEditProviderProfile({
              ...this.profile,
              providerId: this.currentProvider.id,
              phones,
              social_medias,
              covers,
              updateProgress: this.updateProgress,
              abortController: this.abortController,
            })
            .then(() => {
              this.$vs.notify({
                text: "عملیات با موفقیت انجام شد",
                color: "success",
                position: "bottom-center",
              });
              this.$router.go();
            })
            .catch((err) => {
              this.$vs.notify({
                text: err.getErrorDescriptions(),
                color: "danger",
                position: "bottom-center",
              });
            })
            .finally(() => {
              this.progress = 0;
              this.loadingBtn = false;
            });
        }
      },
      updateProgress(percent) {
        this.progress = +percent;
      },
      cancelUpload() {
        this.progress = 0;
        this.loadingBtn = false;
        this.abortController.abort();
      },
      handleUploadLogo(fileBlob) {
        this.profile.logo = fileBlob;
      },
      locationAdded(locationResource) {
        const address = this.mapAddress(locationResource);
        const index = this.addresses.findIndex(
          (item) => item.id === address.id
        );
        if (index === -1) {
          this.addresses.push(address);
        } else {
          this.$set(this.addresses, index, address);
        }
        this.selectAddressVisible = false;
        this.$vs.notify({
          text: "عملیات با موفقیت انجام شد",
          color: "success",
          position: "bottom-center",
        });
      },
      locationRemoved(addressId) {
        this.addresses = this.addresses.filter((item) => item.id !== addressId);
        this.selectAddressVisible = false;
        this.$vs.notify({
          text: "عملیات با موفقیت انجام شد",
          color: "success",
          position: "bottom-center",
        });
      },
    },
    mounted() {
      this.fetchData();
    },
  };
</script>

<style lang="scss">
  .cont {
    .provider-logo-container {
      width: 140px !important;
      margin: 0 auto 50px;
      left: 20px;

      .provider-logo {
        height: 140px !important;
        object-fit: cover;
        object-position: center;
        overflow: hidden;
      }
    }

    .vx-card__actions {
      @media screen and (max-width: 724px) {
        width: 100%;
      }
    }

    .actions-wrapper,
    .qr-wrapper {
      display: flex;
      flex-direction: column;
      gap: 4px;

      @media screen and (max-width: 724px) {
        width: 100%;
        margin-top: 8px;

        .qr-wrapper {
          margin-top: 0;
          flex-direction: row;
        }

        button {
          flex: 1;
          padding-right: 0 !important;
          padding-left: 0 !important;
          font-size: 13px;
        }
      }
    }

    h5 {
      margin: 5px 0;
      color: #626262;
      font-weight: 400;
      cursor: pointer;
    }

    .address-item {
      margin-bottom: 16px;
    }

    .mapContainer {
      position: relative;

      .map {
        width: 400px;
        height: 400px;
      }

      .button {
        position: absolute;
        bottom: 10px;
        left: 20px;
        z-index: 1000;
      }
    }

    .footer {
      background-color: rgba(var(--vs-secondary), 1);
      position: fixed;
      bottom: 16px;
      left: 260px;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      z-index: 100000;
      box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
      max-width: 500px;
      margin: 0 auto;
      padding: 12px;
      border-radius: 12px;

      .save {
        background-color: white !important;
        color: rgba(var(--vs-primary), 1) !important;
        font-weight: 500;
      }

      .enter-menu {
        border: 1px solid white;
        font-weight: 500;
        color: white;
      }

      @media screen and (max-width: 1200px) {
        left: 16px;
        right: 16px;
        padding: 8px;
      }
    }
  }
</style>
